module.exports = __webpack_public_path__ + "img/Volumes.9da13d41.svg";